import React, { ReactNode, useEffect, useState } from 'react';
import { Platform } from 'react-native';

// Only iOS's push fade (~350 ms) is long enough to cover a body that arrives a frame late.
// Android's is over in a few frames, so there a deferred body showed up after it - an empty
// screen with just the header and footer, then everything at once - and the web stack does not
// animate at all. Both render the body straight away.
const DEFER = Platform.OS === 'ios';

/**
 * Renders its children one frame after it mounts (on iOS).
 *
 * A pushed screen only starts its transition once its first render has committed, so a heavy
 * body rendered with it holds the tap until all of it is built - on Bonuses that was a visible
 * pause before anything moved. Held back here, the screen's backdrop, header and footer commit on
 * their own and start fading in at once, and the body is built while the (native) fade runs.
 */
export const AfterFirstFrame = ({ children }: { children: ReactNode }) => {
	const [ready, setReady] = useState(!DEFER);

	useEffect(() => {
		if (ready) return;
		const frame = requestAnimationFrame(() => setReady(true));
		return () => cancelAnimationFrame(frame);
	}, [ready]);

	return ready ? <>{children}</> : null;
};

export default AfterFirstFrame;
